<script setup>
import {useBaseStore} from "~/stores/base";
import {URL_PRODUCT} from "~/utils/constants";
import {Delete} from "@element-plus/icons-vue";
import ModalVoteDeleteConfirm from "~/components/product/ModalVoteDeleteConfirm.vue";
import {voteEditOptionPushSwitch} from "~/api/api.vote";

const BNTOMessage = useNuxtApp().$BNTOMessage
const router = useRouter()
const route = useRoute()

/** emits **/
const emits = defineEmits(["deleted"])

/** props **/
const props = defineProps({
  voteData: {default: {}}
})

/** data **/
const isShowModalDeleteConfirm = ref(false)
const popoverActive = ref(false)

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const userInfo = computed(() => useBaseStore().getterUserInfo)

/** watch **/

/** methods **/
const handleDelete = async () => {
  isShowModalDeleteConfirm.value = true
}
const handleDeleteConfirm = async () => {
  isShowModalDeleteConfirm.value = false
  emits("deleted", props.voteData.shareId)
}
const handleSwitchByLikeType = async (item) => {
  await voteEditOptionPushSwitch({
    shareId: props.voteData.shareId,
    productId: props.voteData.productInfo.productId,
    optionLabels: [item.optionLabel],
    action: item.pushSwitch === 1 ? 0 : 1
  })
  if (item.pushSwitch === 1) {
    BNTOMessage.bellSlash({title: "Notifications for this item muted"})
    item.pushSwitch = 0
  } else {
    BNTOMessage.bell({title: "Notifications for this item unmuted"})
    item.pushSwitch = 1
  }
}
const handleSwitchByProduct = async () => {
  await voteEditOptionPushSwitch({
    shareId: props.voteData.shareId,
    productId: props.voteData.productInfo.productId,
    optionLabels: [1, 2, 3],
    action: props.voteData.noVotePushSwitch === 1 ? 0 : 1
  })
  if (props.voteData.noVotePushSwitch === 1) {
    BNTOMessage.bellSlash({title: "Notifications for this item muted"})
    props.voteData.noVotePushSwitch = 0
  } else {
    BNTOMessage.bell({title: "Notifications for this item unmuted"})
    props.voteData.noVotePushSwitch = 1
  }
}

/** lifecycle **/

</script>

<template>
  <div class="module-vote-item-mobile" v-if="isMobile">
    <div class="product">
      <div class="img">
        <img :src="voteData.productInfo.mainImage.url" alt="">
      </div>
      <nuxt-link
        class="info"
        :to="`${URL_PRODUCT}/${voteData.productInfo.productId}/${voteData.productInfo.handle}?voteId=${voteData.shareId}`"
      >
        <div class="name">{{ voteData.productInfo.productName }}</div>
        <div class="price">{{ voteData.productInfo.currency }}{{ voteData.productInfo.price }}</div>
      </nuxt-link>

      <!-- option -->
      <el-popover
        placement="bottom-end"
        popper-style="padding: 5px 10px;"
        trigger="click"
        v-model:visible="popoverActive"
      >
        <template #reference>
          <div class="option" :class="{popoverActive}">
            <img src="@/assets/img/icon-dots-vertical.svg" alt="dots">
          </div>
        </template>
        <template #default>
          <div class="btn-text-secondary btn-option" @click="handleDelete">
            <el-icon color="#292929" size="16">
              <Delete/>
            </el-icon>
            <span>Delete Vote</span>
          </div>
        </template>
      </el-popover>

    </div>
    <div class="records" v-if="voteData.voteRecords?.length">
      <div class="cell" v-for="(item, index) in voteData.voteRecords">
        <div class="left">
          <img v-if="item.optionLabel === 1" src="@/assets/img/icon-like.png" alt="like">
          <img v-if="item.optionLabel === 2" src="@/assets/img/icon-half-like.png" alt="like">
          <img v-if="item.optionLabel === 3" src="@/assets/img/icon-unlike.png" alt="like">
          <span><span style="font-weight: 650">{{ item.voteNum }} {{
              item.voteNum === 1 ? 'friend' : 'friends'
            }}</span>{{ item.voteNum === 1 ? ' loves' : ' love' }} this. Shared {{ item.latestVoteDate }}</span>
        </div>
        <div class="right" @click="handleSwitchByLikeType(item)">
          <img v-if="item.pushSwitch === 1" src="@/assets/img/icon-bell-alert.svg" alt="icon">
          <img v-if="item.pushSwitch === 0" src="@/assets/img/icon-bell-slash.svg" alt="icon">
        </div>
      </div>
    </div>
    <div class="empty" v-else>
      <div class="cell">
        <div class="left">
          No votes yet. Please share again.
        </div>
        <div class="right" @click="handleSwitchByProduct">
          <img v-if="voteData.noVotePushSwitch === 1" src="@/assets/img/icon-bell-alert.svg" alt="icon">
          <img v-if="voteData.noVotePushSwitch === 0" src="@/assets/img/icon-bell-slash.svg" alt="icon">
        </div>
      </div>
    </div>
    <modal-vote-delete-confirm
      :open="isShowModalDeleteConfirm"
      :product-id="voteData.productInfo.productId"
      :vote-id="voteData.shareId"
      @close="isShowModalDeleteConfirm = false"
      @confirm="handleDeleteConfirm"
    />
  </div>
  <div class="module-vote-item-desktop" v-else>
    <div class="product">
      <div class="img">
        <img :src="voteData.productInfo.mainImage.url" alt="">
      </div>
      <nuxt-link
        class="info"
        :to="`${URL_PRODUCT}/${voteData.productInfo.productId}/${voteData.productInfo.handle}?voteId=${voteData.shareId}`"
      >
        <div class="name">{{ voteData.productInfo.productName }}</div>
        <div class="price">{{ voteData.productInfo.currency }}{{ voteData.productInfo.price }}</div>
      </nuxt-link>

      <!-- option -->
      <el-popover
        placement="bottom-end"
        popper-style="padding: 5px 10px;"
        trigger="click"
        v-model:visible="popoverActive"
      >
        <template #reference>
          <div class="option" :class="{popoverActive}">
            <img src="@/assets/img/icon-dots-vertical.svg" alt="dots">
          </div>
        </template>
        <template #default>
          <div class="btn-text-secondary btn-option" @click="handleDelete">
            <el-icon color="#292929" size="16">
              <Delete/>
            </el-icon>
            <span>Delete Vote</span>
          </div>
        </template>
      </el-popover>

    </div>
    <div class="records" v-if="voteData.voteRecords?.length">
      <div class="cell" v-for="(item, index) in voteData.voteRecords">
        <div class="left">
          <img v-if="item.optionLabel === 1" src="@/assets/img/icon-like.png" alt="like">
          <img v-if="item.optionLabel === 2" src="@/assets/img/icon-half-like.png" alt="like">
          <img v-if="item.optionLabel === 3" src="@/assets/img/icon-unlike.png" alt="like">
          <span><span style="font-weight: 650">{{ item.voteNum }} {{
              item.voteNum === 1 ? 'friend' : 'friends'
            }}</span>{{ item.voteNum === 1 ? ' loves' : ' love' }} this. Shared {{ item.latestVoteDate }}</span>
        </div>
        <div class="right" @click="handleSwitchByLikeType(item)">
          <img v-if="item.pushSwitch === 1" src="@/assets/img/icon-bell-alert.svg" alt="icon">
          <img v-if="item.pushSwitch === 0" src="@/assets/img/icon-bell-slash.svg" alt="icon">
        </div>
      </div>
    </div>
    <div class="empty" v-else>
      <div class="cell">
        <div class="left">
          No votes yet. Please share again.
        </div>
        <div class="right" @click="handleSwitchByProduct">
          <img v-if="voteData.noVotePushSwitch === 1" src="@/assets/img/icon-bell-alert.svg" alt="icon">
          <img v-if="voteData.noVotePushSwitch === 0" src="@/assets/img/icon-bell-slash.svg" alt="icon">
        </div>
      </div>
    </div>
    <modal-vote-delete-confirm
      :open="isShowModalDeleteConfirm"
      :product-id="voteData.productInfo.productId"
      :vote-id="voteData.shareId"
      @close="isShowModalDeleteConfirm = false"
      @confirm="handleDeleteConfirm"
    />
  </div>
</template>

<style scoped lang="scss">
.btn-option {
  margin: 0 auto;
  width: fit-content;
  padding: 5px 10px;
}
</style>

<style scoped lang="scss">
@import "src/assets/config";

.module-vote-item-mobile {
  width: 100%;
  height: 224px;
  border: 0.5px solid $color-BNTO-beige-dark;
  padding: 8px;
  display: flex;
  flex-direction: column;
  position: relative;

  .product {
    width: 100%;
    display: flex;
    align-items: center;

    .img {
      display: flex;

      img {
        width: 53px;
        height: 74px;
      }
    }

    .info {
      width: 100%;
      padding: 8px;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }

      .name {
        width: 90%;
        font-family: "TWK Lausanne";
        font-size: 12px;
        font-style: normal;
        font-weight: 300;
        line-height: 12px; /* 100% */

        // 单行
        word-break: break-all;
        word-wrap: anywhere;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        line-clamp: 1;
        -webkit-line-clamp: 1;
      }

      .price {
        margin-top: 8px;
        font-family: "TWK Lausanne";
        font-size: 12px;
        font-style: normal;
        font-weight: 300;
        line-height: 18px; /* 150% */
      }
    }

    .option {
      cursor: pointer;
      position: absolute;
      right: 8px;
      top: 8px;
      display: flex;
      border: .5px transparent solid;
    }

    .popoverActive {
      border: .5px $color-BNTO-beige-dark solid;
    }
  }

  .records {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .empty {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    color: $color-gray-500;
    text-align: center;
    font-family: "TWK Lausanne";
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px; /* 85.714% */
  }

  .cell {
    border: 1px solid $color-gray-200;
    padding: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      display: flex;
      align-items: center;
      gap: 2px;

      img {
        width: 20px;
        height: 18px;
      }

      span {
        font-family: "TWK Lausanne";
        font-size: 14px;
        font-style: normal;
        font-weight: 300;
        line-height: 19px;
      }
    }

    .right {
      display: flex;
      cursor: pointer;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }
}

.module-vote-item-desktop {
  width: 100%;
  height: 224px;
  border: 0.5px solid $color-BNTO-beige-dark;
  padding: 8px;
  display: flex;
  flex-direction: column;
  position: relative;

  .product {
    width: 100%;
    display: flex;
    align-items: center;

    .img {
      display: flex;

      img {
        width: 53px;
        height: 74px;
      }
    }

    .info {
      width: 100%;
      padding: 8px;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }

      .name {
        width: 90%;
        font-family: "TWK Lausanne";
        font-size: 12px;
        font-style: normal;
        font-weight: 300;
        line-height: 12px; /* 100% */

        // 单行
        word-break: break-all;
        word-wrap: anywhere;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        line-clamp: 1;
        -webkit-line-clamp: 1;
      }

      .price {
        margin-top: 8px;
        font-family: "TWK Lausanne";
        font-size: 12px;
        font-style: normal;
        font-weight: 300;
        line-height: 18px; /* 150% */
      }
    }

    .option {
      cursor: pointer;
      position: absolute;
      right: 8px;
      top: 8px;
      display: flex;
      border: .5px transparent solid;
    }

    .popoverActive {
      border: .5px $color-BNTO-beige-dark solid;
    }
  }

  .records {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .empty {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    color: $color-gray-500;
    text-align: center;
    font-family: "TWK Lausanne";
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px; /* 85.714% */
  }

  .cell {
    border: 1px solid $color-gray-200;
    padding: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      display: flex;
      align-items: center;
      gap: 2px;

      img {
        width: 20px;
        height: 18px;
      }

      span {
        font-family: "TWK Lausanne";
        font-size: 14px;
        font-style: normal;
        font-weight: 300;
        line-height: 19px;
      }
    }

    .right {
      display: flex;
      cursor: pointer;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
